import { Alert, Link } from '@digitools/honest-ui';
import React from 'react';
/**
 * honest-ui rebrand of `./UploadErrorAlerts`, alongside the original until every upload
 * feature is converted. Same two alerts under the same test ids.
 */
const HonestUploadErrorAlerts = ({ errorMessage, apiFailureMessage, languageFile, }) => {
    // honest-ui's Link supplies its own new-tab hint and rel, so the original's aria-label
    // would replace that hint rather than add to it.
    const contactUsLink = (<Link href='/customer/home/contacts' linkType='external' language={languageFile.language}>
      {languageFile.contactUs}
    </Link>);
    return (<>
      {errorMessage && (<Alert type={'error'} data-testid={'error-alert'}>
          <div>
            {errorMessage}
            {errorMessage === languageFile.uploadFileCorrupted && <>{contactUsLink}.</>}
          </div>
        </Alert>)}
      {apiFailureMessage && (<Alert type={'error'} data-testid={'api-error-alert'}>
          {languageFile.apiFailureMessage}
          {contactUsLink}.
        </Alert>)}
    </>);
};
export default HonestUploadErrorAlerts;
